<template lang="pug">
  .container-navibuttons(id="NaviButtons-container")
    el-button-group.float-right
      el-button.left-menu-button.tags(
        id="NaviButtons-toggleTagFilterButton",
        type="text",
        :title="$t('Toggle Tag Filter')",
        :class="{ 'active-filter': tagFilterActive }",
        @click="toggleTagFilterVisibility()"
      )
        font-awesome-icon(icon="tags")
      el-button.left-menu-button.button-sync(
        id="NaviButtons-reloadButton",
        size="mini",
        type="text",
        :class="{ 'active': reloadingMedia, 'fa-spin': reloadingMedia }"
        :title="$t('Reload')",
        @click="reloadLeftComponent()"
      )
        font-awesome-icon(icon="sync")
</template>

<script>

export default {
  props: ['side', 'mode', 'loading'],
  methods: {
    toggleTagFilterVisibility () {
      this.$store.dispatch('Medium/toggleTagFilterVisible')
    },
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    }
  },
  computed: {
    reloadingMedia () {
      return this.$store.state.Medium.media_reloading || this.loading
    },
    tagFilterActive () {
      return this.$store.state.Medium.media_filter[this.side].mediaTags.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-navibuttons {
  margin-right: -11px;
}
.left-menu-button, .left-menu-dropdown-icon {
  font-size: 20px;
  color: $--color-text-primary;
  &:hover {
    color: $--color-primary;
  }
  &.active-filter {
    color: $--color-warning;
  }
  &.tags {
    font-size: 16px;
    margin-top: 4px;
  }
}
.left-menu-button  {
  padding: 10px;
  &.button-sync, &.button-actions {
    opacity: 0.3;
    &.active {
      opacity: 1;
    }
  }
}
.left-menu-dropdown-icon {
  margin-top: -5px;
  padding: 0px 10px 0px 10px;
}
.el-icon-loading {
  line-height: 40px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/NaviButtons.vue